document,
  addEventListener('turbolinks:load', function () {

  // ---------------------------------------------------------------
  // フォーム送信時のチェック処理
  // ---------------------------------------------------------------
  document.querySelectorAll('#web_push-form').forEach((form) => {
    // 予約項目のチェックボックスにイベントリスナーを追加
    document.querySelectorAll('input[name="web_push[m_booking_item_ids][]"]').forEach((checkbox) => {
      checkbox.addEventListener('change', toggleSubmitButton);
    });

    // 初期状態で送信ボタンを無効化するかどうかをチェック
    toggleSubmitButton();
  });

  // ---------------------------------------------------------------
  // 送信ボタンの有効/無効を切り替える関数
  // ---------------------------------------------------------------
  function toggleSubmitButton() {
    const form = document.querySelector('#web-push-form');
    const sendMethodTiming = document.querySelector('input[name="web_push[send_method]"]:checked').dataset.type === 'is_send_method_timing';
    const checkedItems = document.querySelectorAll('input[name="web_push[m_booking_item_ids][]"]:checked');
    const messageElement = document.querySelector('.toggle-message');
    if (sendMethodTiming) {
      if (checkedItems.length > 0) {
        form.querySelector('[type="submit"]').disabled = false;
        if (messageElement) messageElement.innerText = ''; // メッセージをクリア
      } else {
        form.querySelector('[type="submit"]').disabled = true;
        if (messageElement) {
          messageElement.innerText = '予約項目を最低1つ選択してください';
          messageElement.style.color = 'red'; // メッセージの色を赤に設定
        }
      }
    } else {
      form.querySelector('[type="submit"]').disabled = false;
      if (messageElement) messageElement.innerText = ''; // メッセージをクリア
    }
  }
});
